// extracted by mini-css-extract-plugin
export default {"marquee":"style_marquee__pAAi5","propertyStart":"style_propertyStart__zYobb","logoWrapper":"style_logoWrapper__DpvhW"};